import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e0e8196")

_pushScopeId("data-v-3e0e8196")
const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = {
  ref: "mapRef",
  class: "map"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, null, 512)
  ]))
})